import type { UIImage, UIImageCategory } from './types';

export const IMAGE_LIST_FAILED = "We couldn't read this story's images, so nothing was changed. Please try again.";

// The story page and the publish modal both show and write this row
export function pickDisplayedImage(images: readonly UIImage[], category: UIImageCategory): UIImage | null {
  let picked: UIImage | null = null;
  for (const image of images) {
    if (image.imageCategory !== category) continue;
    if (!picked) {
      picked = image;
      continue;
    }
    const order = image.imageOrderNumber || 0;
    const pickedOrder = picked.imageOrderNumber || 0;
    if (order < pickedOrder || (order === pickedOrder && (image.createdAt ?? '') > (picked.createdAt ?? ''))) picked = image;
  }
  return picked;
}
